/**
 * Processes an object's zaps property by truncating titles to a maximum length of 200 characters
 * @param obj - Object that may contain a zaps property with title strings
 * @returns Object with processed zaps if they exist, otherwise the original object
 */
export function processZaps<T extends { zaps?: Array<{ title: string }> }>(
  obj: T,
): T {
  if (obj.zaps && obj.zaps.length > 0) {
    return {
      ...obj,
      zaps: obj.zaps.map((zap) => ({
        ...zap,
        title: zap.title.slice(0, 200),
      })),
    };
  }
  return obj;
}
